//LOCAWEB
export const baseUrl = 'https://reguaapi.agape-sistemas.com/api';
//UNIMED
// export const baseUrl = 'http://192.168.0.20:8082/api';
//LOCAL AGAPE
// export const baseUrl = 'http://192.168.1.2:8082/api';

//localhost - Aponta para a api no Visual Studio
// export const baseUrl = 'https://localhost:7082/api';